import { isFaqs } from '@/utils/isFaqs';
import { useTranslation } from 'next-i18next';
import {
  HelpPageContainer,
  Description,
  Title,
  SmallTitle,
  MenuTitlesContainer,
} from './styledComponent';
import { Fragment } from 'react';
import { useGlobalContext } from '../GlobalProvider';

type HelpMenuProps = {
  currentPage: string;
};

type HelpPageTitlesProps = {
  titles: string[];
  currentPage: string;
};

const HelpMenu = ({ currentPage }: HelpMenuProps) => {
  const { programmeId = 'BAEC' } = useGlobalContext();

  const { t: tFaqs } = useTranslation(`${programmeId}/faqs`);
  //const { t: tContactUs } = useTranslation('contact-us');

  // const description =
  //   currentPage === 'faqs' ? tFaqs('description') : tContactUs('description');
  const description = tFaqs('description');

  return (
    <HelpPageContainer>
      {programmeId !== 'IBP' && (
        <HelpPageTitles
          currentPage={currentPage}
          //titles={[tFaqs('title'), tContactUs('title')]}
          titles={[tFaqs('title')]}
        />
      )}
      <Description>{description}</Description>
    </HelpPageContainer>
  );
};

const HelpPageTitles = ({ titles, currentPage }: HelpPageTitlesProps) => {
  return (
    <MenuTitlesContainer>
      {titles.map((title, index) => {
        return (
          <Fragment key={`${title}-${index}`}>
            {isFaqs(title) ? (
              <>
                <Title
                  $isCurrentPage={'faqs' === currentPage}
                  $isFaqs={isFaqs(title)}
                  href="/help/faqs"
                >
                  {title}
                </Title>
                <SmallTitle
                  $isCurrentPage={'faqs' === currentPage}
                  $isFaqs={isFaqs(title)}
                  href="/help/faqs"
                >
                  FAQs
                </SmallTitle>
              </>
            ) : (
              <Title
                $isCurrentPage={'contact-us' === currentPage}
                $isFaqs={isFaqs(title)}
                href="/help/contact-us"
              >
                {title}
              </Title>
            )}
          </Fragment>
        );
      })}
    </MenuTitlesContainer>
  );
};

export default HelpMenu;
